// @flow
import React from 'react'
import {
  Container,
  Title,
  Description,
  Icon,
  Notifications,
  Box
} from './Styled'

type C = React$StatelessFunctionalComponent<{
  title: string,
  description?: string,
  icon?: string,
  onClick?: (e: MouseEvent) => void,
  style?: {},
  className?: string,
  notifications?: number,
  notificationsMax?: number
}>

const NavCard: C = ({
  title,
  description,
  icon,
  style,
  className,
  onClick,
  notifications,
  notificationsMax = 10
}) => {
  return (
    <Container style={style} className={className} onClick={onClick}>
      <Box margin={!description}>
        {icon && <Icon>{icon}</Icon>}
        {!!notifications && (
          <Notifications>
            {notifications < notificationsMax ? notifications : '+'}
          </Notifications>
        )}
      </Box>
      <Title>{title}</Title>
      {description && <Description>{description}</Description>}
    </Container>
  )
}

export default NavCard



// WEBPACK FOOTER //
// ./src/NavCard.js